<div class="modal-header">
    <h1 class="modal-title"> {{ 'FAQ_INFO_MODAL_TITLE' | translate }} </h1>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <app-loading-animation
        [isRouting]="!faqEntries"
        [width]="100"
        [height]="20"
        [margin]="'auto'"
    >
        <ng-container *ngFor="let faq of faqEntries">
            <h2>{{faq.no}}. {{faq.question}}</h2>
            <p>{{faq.answer}}</p>
        </ng-container>
    </app-loading-animation>
</div>
<div class="modal-footer">
    <button 
      type="button" 
      class="btn btn-outline-dark" 
      (click)="activeModal.close('Close click')"
  >{{ 'FAQ_INFO_MODAL_CLOSE_BTN' | translate }}</button>
</div>